var map = {
	"./altf/bot-avatar.png": "f351",
	"./datarmony/bot-avatar.png": "3de8",
	"./default/bot-avatar.png": "6fed",
	"./euruni/bot-avatar.png": "1dc6",
	"./foundever/bot-avatar.png": "91cf",
	"./gala/bot-avatar.png": "7c57",
	"./ie/bot-avatar.png": "cedc",
	"./sitel-learning-sandbox/bot-avatar.png": "51ac",
	"./sitel-learning/bot-avatar.png": "219a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b276";